import React from 'react';
import ReactWOW from 'react-wow';
import cx from 'classnames';
import LazyLoad from 'react-lazyload';
import SwiperCarousel from '@/modules/SwiperCarousel';
import { getPartnerDataRequest } from '@/modules/request';
import { $t } from '@/modules/i18n';

const Logo = ({ col = 3, link, image, name, defaultName, size = 'contain' }) => {
    const getAnchorLink = (withImage) => (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="logo-link"
            {...(image && withImage
                ? {
                    style: {
                        backgroundImage: `url('${image}')`,
                        backgroundSize: size,
                    },
                }
                : {})}
        >
            {!(image && withImage) ? (<p className="normal-name">{$t(name) || defaultName}</p>) : ''}
            <p className="name">{$t(name) || defaultName}</p>
        </a>
    );

    const className = cx('col-md-' + col, 'col-6', 'logo', {
        'no-image': !image,
    });

    return (
        <ReactWOW animation="fadeIn">
            <div className={className}>
                <LazyLoad placeholder={getAnchorLink()} offset={360} resize>
                    {getAnchorLink(true)}
                </LazyLoad>
            </div>
        </ReactWOW>
    );
};

const Partner = ({ partners, withImage = true }) => {
    return (
        <section id="partners" className="light">
            <div className="container">
                    <div className="title">{$t('microsite_label_partner_title')}</div>
                    {
                        partners.length > 0 && partners[0].logos.length > 0 ? (
                            <>
                                <div className="part-title" >{$t(partners[0].title) || partners[0].defaultTitle}</div>
                                <div className={`row ${partners[0].justifyCenter ? 'justify-content-center' : ''} no-border`} id="noBoder">
                                    {
                                        partners[0].logos.map(element => {
                                            return (
                                                <Logo
                                                    key={element.name}
                                                    col={element.col}
                                                    name={element.name}
                                                    defaultName={element.defaultName}
                                                    image={element.image}
                                                    link={element.link}
                                                    size={element.size}
                                                />
                                            )
                                        })

                                    }
                                </div>
                            </>
                        ) : null
                    }
            </div>
            {
                withImage ? (
                    <SwiperCarousel partners={partners}></SwiperCarousel>
                ) : null
            }
        </section>

    );
}

class SwiperPartners extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            partners: {}
        }
    }

    initPartnerData() {
        getPartnerDataRequest(this.props.micrositeId).then(partners => {
            this.setState({ partners })
        })
    }

    componentDidMount() {
        this.initPartnerData()
    }

    render() {
        const msg = JSON.stringify(this.state.partners) === '{}' ? null : this.state.partners;
        if (msg === null) {
            return null;
        }
        else {
            return (
                <LazyLoad placeholder={<Partner partners={this.state.partners} withImage={false}/>} offset={360} resize>
                    <Partner partners={this.state.partners} />
                </LazyLoad>
            );
        }

    }
};

export default SwiperPartners;
